export default Object.freeze({
  carMakes: "/cars?requestType=make",
  carModels: "/cars?requestType=models",
  carYears: "/cars?requestType=years",
});
